import React from 'react';

import BODACC from '../../components/Monitoring/BODACC';

function BODACCView() {
  return (
    <BODACC />
  );
}

export default BODACCView;
